// extracted by mini-css-extract-plugin
module.exports = {"OrdersContainer":"Orders_OrdersContainer__1aIYb"};